import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.6371 6.44304L17.1492 0.159015C16.9213 -0.0688418 16.6215 0.0151112 16.2977 0.0151112H2.39849C1.07932 0.0151112 0 0.674664 0 2.00582V21.1937C0 22.5129 1.07932 24 2.39849 24H21.5864C22.9056 24 23.9849 22.5129 23.9849 21.1937V7.29453C23.9849 6.97074 23.853 6.65891 23.6371 6.44304ZM21.5864 19.9825C21.5864 20.6421 21.0467 21.5895 20.3872 21.5895H3.59773C2.93815 21.5895 2.39849 20.6421 2.39849 19.9825V3.19307C2.39849 2.53348 2.93815 2.4016 3.59773 2.4016H14.3909V6.7908C14.3909 8.10997 15.4703 9.59706 16.7894 9.59706H21.5864V19.9825ZM14.9666 13.8184L10.1936 16.5527C9.39008 17.0084 8.39471 16.4327 8.39471 15.5093V10.0528C8.39471 9.12936 9.39008 8.55373 10.1936 9.00944L14.9666 11.7437C15.7701 12.1994 15.7701 13.3627 14.9666 13.8184Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
